var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAscending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.129,
    height: 13.91,
    viewBox: "0 0 13.129 13.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30784",
    "data-name": "Group 30784",
    transform: "translate(-342.64 -326.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67925",
    "data-name": "Path 67925",
    d: "M4.89-.638H2.316L1.9.581H.144l2.5-6.9H4.586l2.5,6.9H5.3Zm-.432-1.3L3.6-4.461,2.758-1.935ZM10.305-.8h2.968V.581H8.4V-.7l2.948-4.245H8.4V-6.318h4.874V-5.04Z",
    transform: "translate(342.496 339.33)",
    fill: "#555"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-left",
    "data-name": "Icon awesome-arrow-left",
    d: "M2.532,8.071l.3.3a.318.318,0,0,0,.451,0L5.867,5.78a.318.318,0,0,0,0-.451L3.279,2.741a.318.318,0,0,0-.451,0l-.3.3a.32.32,0,0,0,.005.457l1.6,1.528H.316A.319.319,0,0,0,0,5.341v.426a.319.319,0,0,0,.319.319H4.142l-1.6,1.528A.318.318,0,0,0,2.532,8.071Z",
    transform: "translate(346.852 323.354)",
    fill: "#555"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscending);
export default __webpack_public_path__ + "static/media/ascending.e5e30304cc8f8608583aa3a9c1390c3d.svg";
export { ForwardRef as ReactComponent };